import React from "react";
import TC from "../images/contenido/TC.jpg";
import TC1 from "../images/contenido/TC1.jpg";
import TC2 from "../images/contenido/TC2.jpg";
import Navigation from "../components/Navigation";
import { Helmet } from "react-helmet";

const TribunalConstitucional = () => {
  return (
    <section className="nosotros talleres">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Participación ciudadana en el proceso de selección de magistrados del
          Tribunal Constitucional - Memoria 2014-2024 - Fundación Gustavo Mohme
          Llona
        </title>
        <meta
          property="og:title"
          content="Participación ciudadana en el proceso de selección de magistrados del Tribunal Constitucional - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <div className="pre-title">4.1</div>
            <h1 className="color-brown title-small">
              Participación ciudadana en el proceso de selección de magistrados
              del Tribunal Constitucional
            </h1>
          </div>
          <div className="column-0">
            <div className="cont-mohme-0">
              <img src={TC} alt="Web Tribunal" className="mohme-0 border-img" />
              <div className="legend">
                Espacio creado en la página web de la fundación para difundir
                información acerca de la elección de los miembros del{" "}
                <a target="_blank" rel="noopener" href="https://fundacionmohme.org/recursos/carpetas-de-los-postulantes-al-tribunal-constitucional/">
                  Tribunal Constitucional y el trabajo del panel de expertos
                </a>
                .
              </div>
              <div className="block-brown"></div>
            </div>
            <div className="block-brown-light"></div>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <p>
              Un sistema democrático también se sostiene en sus instituciones.
              Es el caso del Tribunal Constitucional (TC), un órgano
              constitucional autónomo que tiene entre sus funciones la
              interpretación de la carta magna, la resolución en instancia única
              de las acciones de inconstitucionalidad, decidir sobre eventuales
              contiendas de competencia entre distintos organismos del Estado,
              además de decidir en última instancia los procesos
              constitucionales (habeas data, acción de amparo y habeas corpus).
              Es decir, el TC tiene un rol fundamental en decisiones que atañen
              directamente al sistema democrático. El Congreso peruano ha tenido
              procesos fallidos de elección de los magistrados para el TC. En el
              2013, se hicieron públicos audios en los que se escucha a
              congresistas de distintas bancadas repartirse los puestos para las
              designaciones de magistrados del TC, además del defensor del
              Pueblo. En el 2021, el proceso de elección también se frustró por
              incumplimientos del reglamento del proceso.
            </p>
            <div className="quote quote-brown">
              El compromiso de la fundación es con la defensa de la democracia y
              sus instituciones.
            </div>
            <p>
              Para el nuevo concurso público del 2022, la Fundación Gustavo
              Mohme Llona decidió acompañar a un grupo de organizaciones de la
              sociedad civil peruana para la convocatoria de un panel de
              expertos internacionales, en el marco del derecho de participación
              ciudadana. Los especialistas convocados son el jurista venezolano
              Carlos Ayala, quien fue presidente de la Comisión Interamericana
              de Derechos Humanos (CIDH); Daniela Salazar, vicepresidenta de la
              Corte Constitucional en Ecuador; el jurista argentino Eduardo
              Bertoni, en representación del Instituto Iberoamericano de
              Derechos Humanos (IIDH); la magistrada chilena de garantías
              constitucionales María Zapata; y Eduardo Rodríguez, expresidente
              de Bolivia y extitular de la Corte Suprema de Justicia de este
              país. Forman parte de esta iniciativa las organizaciones
              internacionales Fundación para el Debido Proceso (DPLF), la
              Comisión Internacional de Juristas, el Instituto Iberoamericano de
              Derecho Constitucional; y en el Perú acompañan, además de nuestra
              organización, Transparencia, Proética y el Instituto de Defensa
              Legal (IDL).
            </p>
            <figure className="img-center">
              <div className="block-brown"></div>
              <img src={TC1} alt="Expertos convocados" className="" />
            </figure>
            <figure className="img-center">
              <div className="block-brown-light"></div>
              <img src={TC2} alt="Expertos convocados" className="" />
              <div className="legend">
                Los expertos convocados han aparecido en diferentes medios para
                dar a conocer sus puntos de vista sobre el proceso de elección
                de miembros del Tribunal Constitucional.
              </div>
            </figure>
            <p>
              En paralelo, desde la Fundación Gustavo Mohme Llona, habilitamos
              un sitio en nuestra página web con documentación importante de
              este concurso público, para que la ciudadanía pueda ejercer
              también los derechos de vigilancia y participación ciudadana.
            </p>
          </div>
          <Navigation
            prev="https://fundacionmohme.org/especiales/memoria-2024/#otros"
            textPrev="4. Otras iniciativas"
            next="https://fundacionmohme.org/especiales/memoria-2024/premios-trayectoria/"
            textNext="4.2 Premio a la Trayectoria"
          />
        </div>
      </div>
    </section>
  );
};

export default TribunalConstitucional;
